<script setup lang="ts">
import { computed } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { action } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { useWorkModeStore } from "@/store/workMode";

const logoIcon = computed(() =>
  useWorkModeStore().isExecutionMode ? "general/logo-light" : "general/logo",
);
</script>

<template>
  <IconButton
    v-bind="action(toggleActions.showSwitchSession)"
    :icon="logoIcon"
    :aria-label="$t('label.menuTop.changeSession')"
  />
</template>
